module.exports = __webpack_public_path__ + "img/avatar1.ae709359.png";